import { render, staticRenderFns } from "./WaitEditQuestionPage.vue?vue&type=template&id=741b8419&"
import script from "./WaitEditQuestionPage.vue?vue&type=script&lang=js&"
export * from "./WaitEditQuestionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports